module.exports = __webpack_public_path__ + "static/media/pin indicator.a91b2e5e.svg";